import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";

export const useClassroomColumns = (handleEdit, handleDelete) => {
  const [t] = useTranslation();

  return useMemo(
    () => [
      {
        Header: t("admin.room_number"),
        accessor: "room_number",
      },
      {
        Header: t("admin.exam_center"),
        accessor: "exam_center",
        Cell: ({ value }) => value?.name || "-",
      },
      {
        Header: t("admin.region"),
        accessor: "exam_center.region",
        Cell: ({ row }) => row.original.exam_center?.region?.name || "-",
      },
      {
        Header: t("admin.occupied_seats"),
        accessor: "occupied_seats",
      },
      {
        Header: t("admin.max_capacity"),
        accessor: "seat_count",
      },
      // {
      //   Header: t("admin.is_full"),
      //   accessor: "is_full",
      //   Cell: ({ value }) => (value ? t("admin.yes") : t("admin.no")),
      // },
      // {
      //   Header: t("admin.actions"),
      //   accessor: "uuid",
      //   Cell: ({ row }) => (
      //     <div className="flex gap-2">
      //       <Button
      //         Icon={PencilSquareIcon}
      //         onClick={() => handleEdit(row.original)}
      //         color="primary"
      //       />
      //       <Button
      //         Icon={TrashIcon}
      //         onClick={() => handleDelete(row.original)}
      //         color="error"
      //       />
      //     </div>
      //   ),
      // },
    ],
    [t, handleEdit, handleDelete]
  );
};
